import type { StandardCalculatorInputs } from '@context/calculator/inputs-context';
import { get } from '@eika-infrastruktur/request';
import type { FundSavingsCalculationResults } from '@generated-types';
import { getApiUrl } from '@react-query/utils';

export const getCalculatedResults = ({
    initialInvestment,
    monthlyContribution,
    savingPeriodYears,
}: StandardCalculatorInputs): Promise<FundSavingsCalculationResults> => {
    const queryParams = new URLSearchParams({
        initialInvestment: toValidString(initialInvestment),
        monthlyContribution: toValidString(monthlyContribution),
        savingPeriodYears: toValidString(savingPeriodYears),
    });

    const url = `${getApiUrl('savings-calculator/funds/calculate')}?${queryParams.toString()}`;
    return get(url);
};

const toValidString = (value: string | number | undefined) => (value !== undefined ? `${value}` : '');
